import { ErrorEnum } from './error.enum';
import { IErrorMessages } from './types';

/**
 * `defaultValue`s are what i18next renders when the remote translation bundle is not loaded
 * (yet, or at all): an error page must stay readable in exactly those situations.
 */
export const apiErrorMessages: Partial<Record<ErrorEnum, IErrorMessages>> = {
  [ErrorEnum.BAD_REQUEST]: {
    title: { key: 'error.bad-request', defaultValue: 'Bad request' },
    message: { key: 'error.bad-request-reason', defaultValue: 'The request could not be understood.' },
  },
  [ErrorEnum.NOT_AUTHORIZED]: {
    title: { key: 'error.not-allowed', defaultValue: 'Access denied' },
    message: { key: 'error.not-allowed-reason', defaultValue: 'You are not allowed to access this page.' },
  },
  [ErrorEnum.FORBIDDEN]: {
    title: { key: 'error.not-allowed', defaultValue: 'Access denied' },
    message: { key: 'error.not-allowed-reason', defaultValue: 'You are not allowed to access this page.' },
  },
  [ErrorEnum.NOT_FOUND]: {
    title: { key: 'error.page-not-found', defaultValue: 'Page not found' },
    message: { key: 'error.page-not-found-reason', defaultValue: 'The page you are looking for does not exist.' },
  },
  [ErrorEnum.SERVER_INTERNAL_ERROR]: {
    title: { key: 'error.server-internal-error', defaultValue: 'Internal server error' },
    message: { key: 'error.server-internal-error-reason', defaultValue: 'Something went wrong on our side.' },
  },
  [ErrorEnum.APP_CRASH]: {
    title: { key: 'error.app-crash', defaultValue: 'Something went wrong' },
    message: {
      key: 'error.app-crash-reason',
      defaultValue: 'An unexpected error occurred. Reloading the page should fix it; if not, please contact support@jooxter.com.',
    },
  },
};
